// extracted by mini-css-extract-plugin
export default {"Main":"RepairConsole_Main__lUtfx"};